<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2" >
              <div class="w-1/2 bg">
              </div>
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="px-8 pt-8 login-tabs-container">

                <div class="vx-card__title mb-4">
                  <img class="logo mb-2 mx-auto" src="https://firebasestorage.googleapis.com/v0/b/pedido-rapido-app.appspot.com/o/sticky-logo.png?alt=media&token=a5ff609d-6f49-40b2-95fa-80dbb30e4d21"/>
                  <div class="text-center"><h4>Portal do estabelecimento</h4></div>
                </div>

                <vs-divider></vs-divider>

                <LoginFirebase />

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>


<script>
import LoginFirebase from './LoginFirebase.vue'
export default {
  components: {
    LoginFirebase
  },
  beforeCreate () {
    
  },
  created () {

  }
}
</script>

<style lang="scss">
.login-tabs-container {
  min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
.logo {
    width: 100%;
    min-height: 50px;
    max-width: 400px;
}
.bg {
  background-image: url('https://cdn.dribbble.com/users/2150390/screenshots/10856357/media/6f5d09a31069fd9253af73f57032ff2b.jpg');
  background-size: cover;
  position: absolute;
  top: 0;
  bottom: 0;
}
bg::before{
  content: '';
}
</style>
